<core-layout-auth [config]="config">
    @for (field of authFields; track field.key) {
    <ng-container 
      coreDynamicField
      [mode]="ModalMode.EDIT"
      [field]="field"
      [value]="model[field.key.toString()]"
      (valueChange)="onFieldValueChange(field.key.toString(), $event)"/>
  }

  <button 
    type="submit" 
    class="c-login__submit c-btn" 
    [class.is-loading]="loading()"
    (click)="onFormSubmit()">
    {{ 'login.btnLogin' | translate }}
  </button>

  <div class="u-align-center">
    <a 
      [routerLink]="['/auth/forgot-password']" 
      class="c-link--underlined c-link--primary">
      {{ 'login.forgotPassword' | translate }}
    </a>
  </div>
</core-layout-auth>